import { Button, Input, message } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import EmployeeService from '../../../../services/EmployeeService';

const ForgotCard = () => {
    const [userCredentials, setCredentials] = useState({
		email: ""
	});
	const { email } = userCredentials;

	const handleSubmit = async () => {
		const user = await EmployeeService.resend_otp(userCredentials);
		if(user) {
			history.push("/public/verify");
		}
		
	};
    const history = useHistory();

    const onUpdateChange = (e) => {
        const currentData = { ...userCredentials };
        currentData[e.target.name] = e.target.value;
        setCredentials(currentData);
    };
    const onSignUp = async () => {
        if(!userCredentials.email) {
            message.warning("Please enter email id");
        } else {
            message.success("Successfully verified");
        }
    };

    return <div className="right_item">
        <div className="pubheader_sec">
            <div className="pub_title">Welcome to FoodLuv</div>
            <h3 className="sub_title">Forgot Password</h3>
            <div className="logo_sec"><img src="/images/login_icon.png" alt="" /></div>
        </div>
        <div className='w-full'>
            <div className="password_sec w-full">
                <label>Email</label>
                <Input className="w-full" name="email" onChange={onUpdateChange} value={userCredentials.email} />
            </div>
        </div>
        <div className="otp_btns">
            <Button type="primary" className='otp_signup' onClick={handleSubmit}>Send OTP</Button>
        </div>
    </div>
};
 export default ForgotCard;